"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("@package/utils");

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var FORM_NAME = 'invoice-create';

var validate = function validate(values) {
  var errors = {};

  if (!values['deliveryMethod']) {
    errors['deliveryMethod'] = 'Обязательное поле';
  }

  if (!values['phone'] && values['deliveryMethod'] && values['deliveryMethod'] === 'SMS') {
    errors['phone'] = 'Обязательное поле';
  } else {
    if (values['phone'] && !_utils.validation.phone(values['phone'])) {
      errors['phone'] = 'Неверный формат телефона';
    }
  }

  if (!values['email'] && values['deliveryMethod'] && values['deliveryMethod'] === 'EMAIL') {
    errors['email'] = 'Обязательное поле';
  } else {
    if (values['email'] && !_utils.validation.email(values['email'])) {
      errors['email'] = 'Неверный формат email';
    }
  }

  if (!values['shop']) {
    errors['shop'] = 'Обязательное поле';
  }

  if (!values['description']) {
    errors['description'] = 'Обязательное поле';
  } else if (values['description'].length > 1000) {
    errors['description'] = 'Не более 1000 знаков';
  }

  if (!values['amount']) {
    errors['amount'] = 'Обязательное поле';
  } else {
    if (values['amount'] <= 0 || !/^(\d+)(\.\d{1,2})?$/.test(values['amount'])) {
      errors['amount'] = 'Неверный формат суммы';
    }
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: FORM_NAME,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;